// extracted by mini-css-extract-plugin
module.exports = {"crmCarousel":"_0de0961","slickLoading":"_6fb0400","slickInitialized":"_23507a9","slickVertical":"_49b3bd4"};